import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface CreateCardPrefs {
  projectId: string | null;
  squadId: string | null;
  categoryId: string | null;
  remember: (prefs: { projectId: string; squadId: string; categoryId: string }) => void;
}

/**
 * Last project/squad/category chosen in the flight-alerts create-card sheet
 * (Task 13), remembered per browser so operators don't re-pick them on every
 * card. Persisted to localStorage next to the sidebar and command-palette
 * stores — see AGENTS.md ("state (Zustand stores)").
 */
export const useCreateCardPrefs = create<CreateCardPrefs>()(
  persist(
    (set) => ({
      projectId: null,
      squadId: null,
      categoryId: null,
      remember: (prefs) => set(prefs),
    }),
    {
      name: 'voll.alerts.createCard',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ projectId: s.projectId, squadId: s.squadId, categoryId: s.categoryId }),
    },
  ),
);
